export type Bonus = {
  num: string
  icon: string
  title: string
  subtitle: string
  desc: string
}

export const bonuses: Bonus[] = [
  {
    num: '01',
    icon: '🍎',
    title: 'Cocina Vital 60+',
    subtitle: 'Recetas simples y menú semanal',
    desc: 'Recetas simples, menú semanal y lista de compras, para que la comida deje de ser un problema diario.',
  },
  {
    num: '02',
    icon: '👥',
    title: 'Kit de Socialización',
    subtitle: 'Cartas de recuerdos y dinámicas familiares',
    desc: 'Cartas de recuerdos, juegos y dinámicas para hacer con los nietos. Ideal para el domingo en familia.',
  },
  {
    num: '03',
    icon: '🏠',
    title: 'Hogar Seguro',
    subtitle: 'Checklist ambiente por ambiente',
    desc: 'Checklist ambiente por ambiente para detectar riesgos de caída antes de que pase algo.',
  },
]
